// actions.js

export const setProjectFilterOptions = (filterOptions) => ({
    type: 'SET_PROJECT_FILTER_OPTIONS',
    payload: filterOptions,
  });
  
export const resetProjectFilterOptions = () => ({
    type: 'RESET_PROJECT_FILTER_OPTIONS',
});